import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    search: (filterRequest) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'locationTag/search',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.SEARCH_LOCATION_TAGS_REQUEST,
                        types.SEARCH_LOCATION_TAGS_SUCCESS,
                        types.SEARCH_LOCATION_TAGS_FAILURE
                    ]
                }
            });
        },
        saveLocationTag: (locationTag) =>
        (dispatch) => {
            if (locationTag.id === 0) {
                // Create
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'locationTag/create',
                        method: 'POST',
                        body: locationTag,
                        types: [
                            types.CREATE_LOCATION_TAG_REQUEST,
                            types.CREATE_LOCATION_TAG_SUCCESS,
                            types.CREATE_LOCATION_TAG_FAILURE
                        ]
                    }
                });
            } else {
                // Update
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'locationTag/update',
                        method: 'PUT',
                        body: locationTag,
                        types: [
                            types.UPDATE_LOCATION_TAG_REQUEST,
                            types.UPDATE_LOCATION_TAG_SUCCESS,
                            types.UPDATE_LOCATION_TAG_FAILURE
                        ]
                    }
                });
            }
        }         
}